import React, { Component } from 'react'
import PhoneNumber from '../../felles/utils/PhoneNumber';
import Toggle from 'react-toggle'
import NKIcon from '@norkart/ikoner'
import { Grid, Button, ButtonGroup } from 'react-bootstrap'
import _ from 'lodash'
import NkaSelect from 'nka-select'
import Loading from '../../felles/loading'
import Repository from '../../felles/repository'
import { resolve } from '../../dependencies'
import NyMaaler from './nymaaler'
import GammelMaaler from './gammelmaaler'
import Kvittering from './kvittering'

import './vannmaaler.css'

import 'nka-select/dist/style.css'

export default class Vannmaaler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visGammelMaaler: false,
            visNyMaaler: false,
            visKvittering: false,
            visIkkeskiftet: false,
            tilbakeslag: false,
            bildeGammelMaaler: null,
            standGammelMaaler: '',
            bildeNyMaaler: null,
            nyMaaler: null,
            plassering: this.props.PlasseringId,
            gammelMaaler: null,
            forhandsdefinertType: '',
            plasseringEndret: false,
            loraEuid: null            
        }

        this._endrePlassering = this._endrePlassering.bind(this)

        this._visGammelMaaler = this._visGammelMaaler.bind(this)
        this._lukkGammelMaaler = this._lukkGammelMaaler.bind(this)

        this._visNyMaaler = this._visNyMaaler.bind(this)
        this._lukkNyMaaler = this._lukkNyMaaler.bind(this)

        this._visKvitteringForSkifte = this._visKvitteringForSkifte.bind(this)
        this._lukkKvitteringMaaler = this._lukkKvitteringMaaler.bind(this)

        this._skiftMaaler = this._skiftMaaler.bind(this)
        this._lagreBilde = this._lagreBilde.bind(this)

        this._handleTilbakeSikringEndret = this._handleTilbakeSikringEndret.bind(this)

        this._lukkIkkeskiftetModal = this._lukkIkkeskiftetModal.bind(this)
        this._maalerIkkeSkiftet = this._maalerIkkeSkiftet.bind(this)

        this._lagreBilde = this._lagreBilde.bind(this)
    }

    _handleTilbakeSikringEndret(event) {
        this.setState({
            tilbakeslag: event.target.checked
        })
    }

    componentDidMount() {}

    _endrePlassering(event) {
        this.props.endrePlassering(event.target.value)
        this.setState({
            plasseringEndret: true,
            plassering: event.target.value
        })
        this.plass = event.target.value
    }

    _visGammelMaaler() {
        this.setState({
            visGammelMaaler: !this.state.visGammelMaaler
        })
    }

    _visNyMaaler() {
        this.setState({
            visNyMaaler: !this.state.visNyMaaler
        })
    }

    _lukkIkkeskiftetModal() {
        this.setState({
            visIkkeskiftet: !this.state.visIkkeskiftet
        })
    }

    _visKvitteringForSkifte() {
        if (!this.state.nyMaaler || !this.state.gammelMaaler) {
            alert('Må fylle inn data om gammel og ny måler')
        } else {
            this.setState({
                visNyMaaler: false,
                visGammelMaaler: false,
                visKvittering: !this.state.visKvittering
            })
        }
    }

    _lukkNyMaaler(bilder, nyStand, maalerNummer, plombert, type, fjernavlest,loraEuid) {
        let nyMaalerdata = {
            Maalernummer: String(maalerNummer),
            Stand: nyStand,
            Type: type.TypeId,
            Fabrikat: type.FabrikatId,
            Dimmensjon: type.DimensjonId,
            Retning: type.RetningId,
            Antallsiffer: type.Antallsiffer,
            Kapasitet: type.Kapasitet,
            Plombert: plombert,
            Fjernavlest: fjernavlest,
            Temperatur: type.Temperatur
        }

        this.setState({
            visNyMaaler: false,
            nyMaaler: nyMaalerdata,
            forhandsdefinertType: type.Tekst,
            loraEuid
        })

        if (bilder) {
            _.map(bilder, this._lagreBilde)
        }
    }

    _lagreBilde(bilde) {
        this.setState({
            laster: true            
        })
   
        let bildeSomSkalSendes = _.split(bilde.Bilde, ',', 2)[1]
        
        let bildeObjekt = {
            BytteId: this.props.BytteId,
            BildeData: bildeSomSkalSendes,
            Kommentar: bilde.Kommentar
        }
        
        resolve(Repository)
            .leggTilBildeBytte(bildeObjekt)
            .then((resp) => {                        
                this.setState({
                    laster: false            
                })                   
                if (resp.ok == false)          
                {
                    alert("Opplasting av bilde feilet. Det er allikevel mulig å fullføre utskiftingen av vannmåler, men bildet vil ikke bli lagret.")
                }
            })
            
    }

    _lukkGammelMaaler(bilder, nyStand, maalerGattRundt) {    

        let gammelMaaler = {
            Stand: nyStand,
            Maalernummer: this.props.MaalerNummer,
            SisteStand: this.props.SisteStand,
            SisteForbruk: this.props.SisteForbruk,
            MaalerGattRundt: maalerGattRundt
        }

        this.setState({
            visGammelMaaler: false,
            gammelMaaler: gammelMaaler
        })

        if (bilder) {
         
            _.map(bilder, this._lagreBilde)
        }
    }

    _lukkKvitteringMaaler() {
        this.setState({
            visKvittering: false
        })
    }

    _skiftMaaler() {
        let bytteData = {
            Maalerplassering: this.state.plassering,
            GammelMaaler: this.state.gammelMaaler,
            NyMaaler: this.state.nyMaaler,
            Tilbakeslagsikring: this.state.tilbakeslag
        }
        
        this.props.utfoerMaalerSkifte(bytteData, this.state.loraEuid)
    }

    _maalerIkkeSkiftet(bilder, info) {
        this.props.maalerIkkeSkifet(bilder, info)
    }

    render() {
        if (this.state.laster) {
            return <Loading tekst="Laster opp bilde" />
        }

        return (
            <Grid>
                <h2>{this.props.MaalepunktAdresse}</h2>
                <strong className="font16">{this.props.Eiernavn} </strong>
                <br />
                Tlf: <PhoneNumber number={this.props.Mobilnummer} isLinked={true} /> /{' '}
                <PhoneNumber number={this.props.Telefonnummer} isLinked={true} />
                <br />
                <p>Avtaletype: {this.props.Avtaletype}</p>
                <div className="plassering" style={{ marginBottom: 5 + 'px' }}>
                    <strong className="font16">Målepunkt</strong>
                    <br />
                    <strong className="font14">Plassering</strong>
                    <br />

                    <NkaSelect
                        id="type"
                        onChange={this._endrePlassering}
                        value={
                            this.state.plasseringEndret
                                ? this.state.plassering
                                : this.props.PlasseringId
                        }
                    >
                        {_.map(this.props.Plasseringer, function(o, i) {
                            return (
                                <option key={i} value={o.Id}>
                                    {o.Tekst}
                                </option>
                            )
                        })}
                    </NkaSelect>
                    <p>{this.props.PlasseringFritekst}</p>
                    <strong className="font14">Tilbakeslagsikring</strong>
                    <br />
                    <Toggle
                        defaultChecked={this.state.tilbakeslag}
                        onChange={this._handleTilbakeSikringEndret}
                    />
                </div>
                <ButtonGroup vertical block style={{ marginBottom: 5 + 'px' }}>
                    <Button onClick={this._visGammelMaaler} className="maalerKnapp">
                        <div style={{ float: 'right', overflow: 'hidden' }}>
                            {this.state.visGammelMaaler ? (
                                <NKIcon icon="opp" color="nk-black" size="1" />
                            ) : (
                                <NKIcon icon="ned" color="nk-black" size="1" />
                            )}
                        </div>
                        <div style={{ float: 'left', overflow: 'hidden' }}>
                            <strong className="font16">Gammel måler</strong>
                        </div>
                        <div style={{ float: 'none', clear: 'both' }} />
                        <div
                            style={{ float: 'left', overflow: 'hidden' }}
                            className="marginTopMinus10"
                        >
                            <strong className="font14">{this.props.MaalerNummer}</strong>,{' '}
                            {this.props.Retning}, {this.props.Dimensjon}
                        </div>
                    </Button>
                </ButtonGroup>
                {this.state.visGammelMaaler && (
                    <div className="hvitBakgrunn">
                        <GammelMaaler
                            onClose={this._lukkGammelMaaler}
                            sisteStand={this.props.SisteStand}
                            avlesningstype={this.props.Avlesningstype}
                            maalerInfo={this.state.gammelMaaler}
                            sisteForbruk={this.props.SisteForbruk}
                            sisteAvlesningsdato={this.props.SisteAvlesningsdato}
                        />
                    </div>
                )}
                <ButtonGroup vertical block style={{ marginBottom: 5 + 'px' }}>
                    <Button onClick={this._visNyMaaler} className="maalerKnapp">
                        <div style={{ float: 'right', overflow: 'hidden' }}>
                            {this.state.visNyMaaler ? (
                                <NKIcon icon="opp" color="nk-black" size="1" />
                            ) : (
                                <NKIcon icon="ned" color="nk-black" size="1" />
                            )}
                        </div>
                        <div style={{ float: 'left', overflow: 'hidden' }}>
                            <strong className="font16">Ny måler</strong>
                        </div>
                        <div style={{ float: 'none', clear: 'both' }} />
                    </Button>
                </ButtonGroup>
                {this.state.visNyMaaler && (
                    <div className="hvitBakgrunn">
                        <NyMaaler
                            onClose={this._lukkNyMaaler}
                            Retninger={this.props.Retninger}
                            Vannmaalertyper={this.props.VannmaalerTyper}
                            Fabrikater={this.props.Fabrikater}
                            Dimensjoner={this.props.Dimensjoner}
                            maalerInfo={this.state.nyMaaler}
                        />
                    </div>
                )}
                <ButtonGroup vertical block style={{ marginBottom: 5 + 'px' }}>
                    <Button
                        bsStyle="primary"
                        className="maalerKnapp"
                        onClick={this._visKvitteringForSkifte}
                    >
                        <div style={{ overflow: 'hidden' }}>
                            <span className="font16">Fullfør</span>
                        </div>
                        <div style={{ float: 'none', clear: 'both' }} />
                    </Button>
                </ButtonGroup>
                {this.state.visKvittering && (
                    <Kvittering
                        gammelMaalerData={this.state.gammelMaaler}
                        nyMaalerData={this.state.nyMaaler}
                        type={this.state.forhandsdefinertType}
                        loraEuid = {this.state.loraEuid}
                        isOpen={this.state.visKvittering}
                        skiftMaaler={this._skiftMaaler}
                        onClose={this._lukkKvitteringMaaler}
                    />
                )}
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/vannmaaler.jsx